// src/components/Topbar.jsx
import React, { useEffect, useState } from "react";
import {
  FaSignOutAlt,
  FaUserCircle,
  FaBars,
  FaTachometerAlt,
  FaGift,
  FaComments,
  FaClipboardList,
  FaBell,
  FaUsers,
  FaUserShield,
  FaMoneyBill,
  FaKey,
} from "react-icons/fa";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import "../styles/TopSide.css";
import NotificationBell from "./NotificationBell";
import logo from "../Assets/Images/AmericanLogo.png";

const Topbar = ({ onOpenUserDetails, onToggleSidebar, isAdmin }) => {
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.username || "Admin");
        setRole(decoded.role || "");
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    } else {
      navigate("/");
    }
  }, [navigate]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from the system.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("authToken");
        navigate("/");
      }
    });
  };

  const isActive = (path) => location.pathname === path;
  const closeMenu = () => setMenuOpen(false);

  const actions = (
    <div className="navbar-actions">
      <NotificationBell />
      <span className="navbar-welcome">Welcome, {username}</span>
      <span
        className="profile-icon"
        title="Profile"
        role="button"
        onClick={() => navigate("/profile")}
      >
        <FaUserCircle />
      </span>
      <button className="logout-button" onClick={handleLogout}>
        <FaSignOutAlt className="logout-icon" />{" "}
        <span className="logout-text">Logout</span>
      </button>
    </div>
  );

  /* ── Admin: simple topbar with hamburger to toggle sidebar ── */
  if (isAdmin) {
    return (
      <div className="topbar-admin">
        <button
          className="navbar-hamburger navbar-hamburger--visible"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FaBars />
        </button>
        {actions}
      </div>
    );
  }

  /* ── Other roles: full horizontal navbar with links ── */
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img src={logo} alt="Logo" className="navbar-logo" />
      </div>

      <button
        className="navbar-hamburger"
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
      >
        <FaBars />
      </button>

      <ul className={`navbar-links ${menuOpen ? "navbar-links--open" : ""}`}>
        <li>
          <Link
            to="/dashboard"
            className={isActive("/dashboard") ? "nav-link active" : "nav-link"}
            onClick={closeMenu}
          >
            <FaTachometerAlt className="nav-icon" /> Dashboard
          </Link>
        </li>
        {role === "branding" && (
          <li>
            <Link
              to="/promotions"
              className={
                isActive("/promotions") ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              <FaGift className="nav-icon" /> Promotions
            </Link>
          </li>
        )}
        {(role === "Csd" || role === "csd") && (
          <li>
            <Link
              to="/assistances"
              className={
                isActive("/assistances") ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              <FaComments className="nav-icon" /> Assistances
            </Link>
          </li>
        )}
        {(role === "Csd" || role === "csd") && (
          <li>
            <Link
              to="/requests"
              className={isActive("/requests") ? "nav-link active" : "nav-link"}
              onClick={closeMenu}
            >
              <FaClipboardList className="nav-icon" /> Requests
            </Link>
          </li>
        )}
        {(role === "Csd" || role === "csd") && (
          <li>
            <Link
              to="/otp-lookup"
              className={isActive("/otp-lookup") ? "nav-link active" : "nav-link"}
              onClick={closeMenu}
            >
              <FaKey className="nav-icon" /> Customer Lookup
            </Link>
          </li>
        )}
        {role === "manager" && (
          <li>
            <Link
              to="/notifications"
              className={
                isActive("/notifications") ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              <FaBell className="nav-icon" /> Notifications
            </Link>
          </li>
        )}
        {role === "manager" && (
          <li>
            <Link
              to="/customers"
              className={
                isActive("/customers") ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              <FaUsers className="nav-icon" /> Customers
            </Link>
          </li>
        )}
      </ul>

      {actions}
    </nav>
  );
};

export default Topbar;
